import { create } from 'zustand'

import type { PopularItemStats, PopularItemsById } from '../domain/popular-items'

interface PopularItemsStore {
  popularItems: PopularItemsById
  setPopularItems: (popularItems: PopularItemsById) => void
}

export const usePopularItemsStore = create<PopularItemsStore>((set) => ({
  popularItems: new Map(),
  setPopularItems: (popularItems: PopularItemsById) => set({ popularItems }),
}))

export const useIsPopularItem = (itemId: string) =>
  usePopularItemsStore((state) => state.popularItems.has(itemId))

export const usePopularItemStats = (itemId: string): PopularItemStats | null =>
  usePopularItemsStore((state) => state.popularItems.get(itemId) ?? null)
